<div>
  <label
    id="listbox-label"
    class="block text-sm font-medium leading-6 text-gray-900"
    >{{ label }}</label
  >
  <div class="relative mt-2" #ref>
    <button
      type="button"
      class="relative w-full cursor-default h-[46px] rounded-[4px] border-[2px] bg-white py-1.5 pl-4 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-black text-sm leading-6"
      aria-haspopup="listbox"
      aria-expanded="true"
      aria-labelledby="listbox-label"
      (click)="toggle()"
    >
      <span class="block truncate">{{ itemNames || placeholder }}</span>
      <span
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
      >
        <svg
          class="h-5 w-5 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
            clip-rule="evenodd"
          />
        </svg>
      </span>
    </button>

    <ul
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-sm transition ease-in duration-100"
      [class.opacity-0]="!opened"
      [class.hidden]="!opened"
      [class.opacity-100]="opened"
      tabindex="-1"
      role="listbox"
      aria-labelledby="listbox-label"
      aria-activedescendant="listbox-option-3"
    >
      <li
        *ngFor="let item of items"
        class="text-gray-900 relative cursor-default select-none py-2 px-4"
        [id]="item.value"
        role="option"
      >
        <ark-checkbox
          [label]="item.name"
          [selected]="item.selected || false"
          [value]="item.value"
          (valueChanged)="itemChange(item, $event)"
        ></ark-checkbox>
      </li>
    </ul>
  </div>
</div>
